import { List } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const FileList = ({ loading, data = [], onDelete, hideDeleteBtn }) => {
  if (!data.length) return null;
  return (
    <List
      className='demo-loadmore-list'
      loading={loading}
      itemLayout='horizontal'
      dataSource={data}
      renderItem={(item) => {
        return (
          <List.Item
            actions={
              !hideDeleteBtn
                ? [
                    <a key='list-loadmore-edit' onClick={() => onDelete(item)}>
                      <DeleteOutlined />
                    </a>,
                  ]
                : []
            }
          >
            <List.Item.Meta
              title={
                <a target='_blank' download href={item.file.url}>
                  {item.file.file_name}
                </a>
              }
            />
          </List.Item>
        );
      }}
    />
  );
};

FileList.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  onDelete: PropTypes.func,
};

export default FileList;
